import React from "react";
import DonationIcon from "../../../../../images/donation/donating-hands.svg";
// import EventIcon from '../../../../../images/common/event-blue.svg';
// import PlanIcon from '../../../../../images/common/plan.svg';
import ContactIcon from "../../../../../images/common/user-blue.svg";
import PaymentIcon from "../../../../../images/membership/dollar-blue.svg";
import InvoiceIcon from "../../../../../images/common/invoice-blue.svg";
import RecurringIcon from "../../../../../images/membership/recurring.svg";
import ItemDetailIcon from "../../../../../images/sidebar/item-details-logo.svg";
import CheckoutIcon from "../../../../../images/common/link-blue.svg";
// import CourseIcon from '../../../../../images/common/course.svg';
// import BundleIcon from '../../../../../images/common/bundle.svg';
import TrioBallsIcon from "../../../../../images/common/ball-trio.svg";
import ServiceIcon from "../../../../../images/common/service.svg";
import ProductIcon from "../../../../../images/common/product.svg";
import { NavigateFunction } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { ItemDropDownOptions } from "../enums";
import { CustomButton, withRouter } from "@mindmemobile/mm-shared-global";
import { CustomLine } from "../styles";

type State = {
  isOpen: boolean;
  isItemOpen: boolean;
};
type Props = {
  navigate: NavigateFunction;
  header: string;
  onHeaderClick?: (title?: keyof typeof ItemDropDownOptions) => void;
  showSplitDropdown?: boolean;
};

type NewitemDropDownData = {
  title: string;
  icon: string;
  onClick: () => void;
};

class NewItemDropDown extends React.Component<Props, State> {
  wrapperRef = React.createRef<HTMLDivElement>();

  constructor(props: any) {
      super(props);
      this.state = {
          isOpen: false,
          isItemOpen: false,
      };
      this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount(): void {
      document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event: any) {
      if (this.wrapperRef && !this.wrapperRef?.current?.contains(event.target)) {
          this.toggleMenu(false);
          this.toggleItemMenu(false);
      }
  }

  toggleMenu(isOpen: boolean) {
      this.setState({ isOpen });
  }

  toggleItemMenu(isItemOpen: boolean) {
      this.setState({ isItemOpen });
  }

  get newitemDropDownData(): NewitemDropDownData[] {
      return [
          {
              title: 'Contact',
              icon: ContactIcon,
              onClick: () => this.props.onHeaderClick && this.props.onHeaderClick(ItemDropDownOptions.Contacts),
          },
          {
              title: 'Payment',
              icon: PaymentIcon,
              onClick: () => this.props.onHeaderClick && this.props.onHeaderClick(ItemDropDownOptions.Payments),
          },
          {
              title: 'Invoice',
              icon: InvoiceIcon,
              onClick: () => this.props.onHeaderClick && this.props.onHeaderClick(ItemDropDownOptions.Invoices),
          },
          {
              title: 'Subscription',
              icon: RecurringIcon,
              onClick: () => this.props.onHeaderClick && this.props.onHeaderClick(ItemDropDownOptions.Subscriptions),
          },
          {
              title: 'Item',
              icon: ItemDetailIcon,
              onClick: () => {
                  this.setState({ isItemOpen: !this.state.isItemOpen });
              },
          },
      ];
  }

  get itemSubMenuData(): NewitemDropDownData[] {
      return [
          {
              title: 'Product',
              icon: ProductIcon,
              onClick: () => this.props.navigate('/app/product/detail'),
          },
          {
              title: 'Service',
              icon: ServiceIcon,
              onClick: () => this.props.navigate('/app/service/detail'),
          },
          {
              title: 'Membership',
              icon: TrioBallsIcon,
              onClick: () => this.props.navigate('/app/membership/detail'),
          },
          {
              title: 'Donation',
              icon: DonationIcon,
              onClick: () => this.props.navigate('/app/donation/detail'),
          },
      ];
  }

  get remainingDropDownItems(): NewitemDropDownData[] {
      return [
          {
              title: 'Checkout',
              icon: CheckoutIcon,
              onClick: () => this.props.navigate('/app/checkout/detail'),
          },
      ];
  }

  render(): React.ReactNode {
      const { header, showSplitDropdown = false } = this.props;
      return (
          <div ref={this.wrapperRef}>
              <CustomButton
                  bgColor="#556bb8"
                  color="#fff"
                  height="40px"
                  borderRadius={'4px !important'}
                  fontSize={'17px'}
                  disabled={!this.props.onHeaderClick || header === 'New Order'}
                  onClick={() => {
                      if (header === 'New Item' || header === 'Create') {
                          this.toggleMenu(!this.state.isOpen);
                      }
                      this.props?.onHeaderClick && this.props.onHeaderClick();
                  }}
                  className={header === 'Create' ? 'split-custom-btn' : ''}
              >
                  {header}
                  {showSplitDropdown && (
                      <div className="split-wrapper">
                          <CustomLine height="90%" bgColor="#fff" width="1px" />
                          <i className="fa fa-solid fa-angle-down"></i>
                      </div>
                  )}
              </CustomButton>
              {this.state.isOpen && (
                  <div className="dropdown-menu add-new-dpdn">
                      <div>
                          {header === 'New Item' ? (
                              <div>
                                  {this.itemSubMenuData.map((subItem, idx) => (
                                      <Dropdown.Item key={idx} onClick={subItem.onClick} className="dropdown-item">
                                          <img src={subItem.icon} alt={subItem.title} />
                                          {subItem.title}
                                      </Dropdown.Item>
                                  ))}
                              </div>
                          ) : (
                              <>
                                  {this.newitemDropDownData.map((item, idx) => (
                                      <Dropdown.Item key={idx} onClick={item.onClick} className="dropdown-item">
                                          <img src={item.icon} />
                                          {item.title}
                                      </Dropdown.Item>
                                  ))}
                                  {this.state.isItemOpen && (
                                      <div style={{ padding: '5px 30px' }}>
                                          {this.itemSubMenuData.map((subItem, idx) => (
                                              <Dropdown.Item
                                                  key={idx}
                                                  onClick={subItem.onClick}
                                                  className="dropdown-item"
                                              >
                                                  <img src={subItem.icon} alt={subItem.title} />
                                                  {subItem.title}
                                              </Dropdown.Item>
                                          ))}
                                      </div>
                                  )}
                                  {this.remainingDropDownItems.map((item, idx) => (
                                      <Dropdown.Item key={idx} onClick={item.onClick} className="dropdown-item">
                                          <img src={item.icon} alt={item.title} />
                                          {item.title}
                                      </Dropdown.Item>
                                  ))}
                              </>
                          )}
                      </div>
                  </div>
              )}
          </div>
      );
  }
}

export default withRouter(NewItemDropDown);
